const KW = {
  ibanLength: 30,
};
export { KW };
